import { Component, OnInit, ViewChild } from '@angular/core';
import { Article_ProcessAPIModel } from './article-process-model';
import { ApiMethod } from '../../apimethods/api-method';
import { ActivatedRoute, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { DataParam, customfunctions } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
declare var $;


@Component({
  selector: 'app-article-process',
  templateUrl: './article-process.component.html',
  styleUrls: ['./article-process.component.css']
})
/** ArticleProcess component*/
export class ArticleProcessComponent implements OnInit {
  modelItem = new Article_ProcessAPIModel();
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  title: string
  popUpButtonText: string;
  /** ArticleProcess ctor */
  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <Article_ProcessAPIModel>data["ArticleProcessPage"];
        this.MainGridTable();
        this.GetProcessName();


        $('#ddlPreviousProcessID').select2({
          placeholder: "Select Previous Process Name",
          allowClear: true, tags: true,
          dropdownParent: "#popupbody"

        });      

        $('#ddlNextProcessID').select2({
          placeholder: "Select Next Process Name",
          allowClear: true, tags: true,
          dropdownParent: "#popupbody"
        });

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  // next Nd Previous Process Name
  GetProcessName(): void {

    ApiMethod.getMethod(this.modelItem.GetProcessName).subscribe(
      result => {
        this.GetProcessName = result.aGetProcessName;
        console.log(result.aGetProcessName);
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Grid Show
  MainGridTable() {
    $("LoadingImage").show();

    var dataparam = {
      ID:localStorage.aEID,
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      ModuleName: "ArticleProcessModule"
    }
    ApiMethod.postMethod(this.modelItem.GetArticleProcessGrid, dataparam).subscribe(
      Response => {
        this.dataSet = JSON.stringify(Response.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //console.log(Response.aitemList);
        //console.log(Response.acolListL);

        //Dynamic datable
        let aColList = Response.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'ArticleProcessModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  //ShowID
  GetArticleProcessByID(): void {
    $("LoadingImagePopup").show();
    this.ClearData();
    $('#btnPopupartDetails').show();
    if (localStorage.aEID != 0) {
      ApiMethod.getMethod(this.modelItem.GetArticleProcessByID + "/" + localStorage.aEID).subscribe(
        Response => {
          var aitems = Response.articleProcess;
          console.log(Response.articleProcess);
          
          $('#ddlPreviousProcessID').val(aitems[0].PreviousProcessID).change();      
          $('#Txt_ProcessName').val(aitems[0].ProcessName);

          if (aitems[0].NextProcessID != null) {
            var data = aitems[0].NextProcessID.split(',');
          } else
            data = null;
          var selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlNextProcessID').val(selectedValues).change();
          if (aitems[0].IsTransaction == 1) {
            $('#Txt_Transaction').prop('checked', true);
          } else {
            $('#Txt_Transaction').prop('checked', false);
          }
          this.title = " Process Name: " + aitems[0].ProcessName + " ";
          this.popUpButtonText = "Update";
          $("LoadingImagePopup").hide();
        },
        error => {
        
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.message, "error");
        });
    } else {
      //show popup
      $('#btnPopupartDetails').show();

      //Title and button Values
      this.popUpButtonText = "Add";
      this.title = " Add Article Process ";
      localStorage.aEID = "";
      $("LoadingImagePopup").hide();
    }

  }

  //AddUpdate Function
  AddUpdateArticleProcess(): void {
    //Validation 
    if ($('#Txt_ProcessName').val().trim() == '') {
      ngswal("Warning !", "Enter Process Name!", "warning");
    }
    else {
      //Getting Updated value
      $("#LoadingImagePopup").hide();
      var isTransaction = $('#Txt_Transaction').prop('checked');
      if (isTransaction == true) {
        isTransaction = 1;
      } else {
        isTransaction = 0;
      }
      var dataparam = {

        ID: localStorage.aEID,
        NextProcessID: $('#ddlNextProcessID').val().toString(),
        PreviousProcessID: $('#ddlPreviousProcessID').val(),
        ProcessName: $('#Txt_ProcessName').val(),

        IsTransaction: isTransaction,
      };
      ApiMethod.postMethod(this.modelItem.AddUpdateArticleProcess, dataparam).subscribe(
        response => {
          this.MainGridTable();
          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.addEditArticleProcess,
            showConfirmButton: true,

          });

        },
        error => {
          ngswal("Failed !", error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  //Delete PopUp
  DeleteArticleProcess() {

    ngswal({
      title: "Are you confirm to delete Process  Details?",
      text: "Process Details deleted permenently!",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your data is safe :)", "warning");
          return false;
        }
      });
  }
  // Delete the Id
  DeleteConfirm() {
    $('#LoadingImagePopup').show();

    ApiMethod.getMethod(this.modelItem.DeleteArticleProcess + localStorage.aEID).subscribe(
      result => {
        this.MainGridTable();
        $("#LoadingImagePopup").hide();
        this.hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted Successfully!",
          text: result.deleteMsg,
          showConfirmButton: false,
          timer: 1500
        });
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  hide() {
    this.ClearData();
    $('#btnPopupartDetails').hide();
  }
  ClearData() {
    $('#ddlNextProcessID').val(0).change();
    $('#ddlPreviousProcessID').val(0).change();
    $('#Txt_ProcessName').val('');
    $('#Txt_Transaction').val('');
  }

}
